import React from 'react'
import RatingServicesListItem from './RatingServicesListItem'
import { MwButton, MwSpinnerButton, NoDataFound } from '../../components/ui'
import { useTranslation } from 'react-i18next'

const RatingServicesList = ({
    showConfirmDelete,
    setShowConfirmDelete,
    selectedDeleteId,
    setSelectedDeleteId,
    deleteLoading,
    deleteHandler,
    addNewHandler,
    data,
    loading}) => {
    const [t] = useTranslation('global')
    const services = Array.isArray(data?.data) ? data.data : []
    return (
        <div className='h-full '>
            {
                loading ? 
                    <MwSpinnerButton isFullCenter={true} withLabel={false}/>
                    : services.length > 0 ?
                        <div className='grid grid-cols-5 gap-3'>
                            {
                                services.map( (item) => <RatingServicesListItem 
                                showConfirmDelete ={showConfirmDelete}
                                setShowConfirmDelete ={setShowConfirmDelete}
                                selectedDeleteId={selectedDeleteId}
                                setSelectedDeleteId={setSelectedDeleteId}
                                deleteLoading={deleteLoading} 
                                deleteHandler={deleteHandler} 
                                key={item._id} 
                                item={item}/>)
                            }
                        </div>:
                        <NoDataFound msg={t('services.noServices')}>
                            <div className='flex gap-3  justify-center items-center'>
                                <MwButton onClick={addNewHandler} type='saveBtn'>{t('services.addNew')}</MwButton> 
                            </div>
                        </NoDataFound>
            }
            
        </div>
    )
}

export default RatingServicesList
